import React, { FC } from 'react';
import { ApprovalModalGexCommentProps } from './ApprovalModalGexCommentProps';
import { Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';
import Text from '@ingka/text';
import TextArea from '@ingka/text-area';
const ApprovalModalGexComment: FC<ApprovalModalGexCommentProps> = ({
  gexComment,
  setGexComment,
}) => {
  const t = useTranslation();
  return (
    <Stack spacing={2}>
      <Stack>
        <Text style={{ fontWeight: '700' }}>{t('ppm.GEX.comment')}</Text>
      </Stack>
      <TextArea
        label={t('common.comment')}
        value={gexComment}
        onChange={(e) => {
          setGexComment(e.target.value);
        }}
      />
    </Stack>
  );
};

export default ApprovalModalGexComment;
